import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";

const dspClientImportRowSchema = z.object({
  profile_id: z.string(),
  entity_id: z.string().nullable(),
  name: z.string().nullable(),
  country_code: z.string().nullable(),
  advertiser_count: z.number().nullable(),
  dsp_client_id: z.number().nullable(),
  status: z.enum(["eligible", "created", "exists", "no_advertisers", "error"]),
  detail: z.string(),
});

export type DSPClientImportRow = z.infer<typeof dspClientImportRowSchema>;

const dspClientImportResponseSchema = z.object({
  data: z.array(dspClientImportRowSchema),
});

export const dspClientApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "previewDSPClients",
    method: "get",
    path: "/dsp/clients/",
    parameters: [
      {
        name: "org",
        type: "Query",
        schema: z.string(),
      },
    ],
    status: 200,
    response: dspClientImportResponseSchema,
  })
    .addEndpoint({
      alias: "importDSPClients",
      method: "post",
      path: "/dsp/clients/",
      parameters: [
        {
          name: "body",
          type: "Body",
          schema: z.object({
            org: z.string(),
            profile_ids: z.array(z.string()),
          }),
        },
      ],
      status: 200,
      response: dspClientImportResponseSchema,
    })
    .build(),
);
